import * as React from "react";
import { forwardRef } from "react";
const SvgExpand05 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.5 7.5L17.5 2.5M17.5 7.5V2.5H12.5M7.5 7.5L2.5 2.5M7.5 2.5L2.5 2.5L2.5 7.5M7.5 12.5L2.5 17.5M2.5 12.5L2.5 17.5H7.5M12.5 12.5L17.5 17.5M12.5 17.5H17.5V12.5", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgExpand05);
export { ForwardRef as ReactComponent };
